<template>
	<b-modal ref="mdlDatiDocumento" title="Dati Documento" centered size="lg" @show="onShowDatiDocumento"
		@ok="onOkModificaDatiDocumento" :no-close-on-backdrop="true" :no-close-on-esc="true">
		<div class="sa-form-section sa-search-box">
			<b-row class="p-3">
				<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
					<label class="sa-search-box-label">{{ this.$i18n.t("billing.lblDocumentType") }}</label>
					<b-form-select class="sa-search-input" v-model="localData.tipoDocumentoId"
						:options="contabilitaTipoDocumentoOptions" :disabled="isDisabled()"
						text-field="descrizioneTipoDocumento" value-field="id" :value="null"
						@change="onChangeTipoDocumento">
						<template #first>
							<b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
						</template>
					</b-form-select>
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
					<label class="sa-search-box-label">{{ this.$i18n.t("billing.lblCausaleDocumentoCodice") }}</label>
					<b-form-select id="inline-form-custom-select-pref" v-model="localData.causaleDocumentoId"
						@change="onChangeCausaleDocumento" class="sa-search-input" :disabled="isDisabled()"
						:options="contabilitaCausaliDocumentoOptions" text-field="descrizioneCausale" value-field="id"
						:value="null">
						<template #first>
							<b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
						</template>
					</b-form-select>
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
					<label class="sa-search-box-label">{{ this.$i18n.t("billing.lblDocumentNumber") }}</label>
					<input class="sa-search-box-input" v-model="localData.documentoNumero"
						placeholder="Numero Documento" :disabled="isTastoNumeroDocumentoEnabled()" />
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="6" lg="6  " xl="6">

					<label class="sa-search-box-label">{{ this.$i18n.t("billing.lblDate") }}</label>
					<date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="localData.documentoData"
						type="timestamp" class="sa-datepicker-minimal" placeholder="Data Documento"></date-picker>
				</b-col>
			</b-row>
		</div>
	</b-modal>
</template>

<script>
import toast from "../../../template/layout/utility/sa-toast";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import UtilityMixin from "../../utility/UtilityMixin";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import DatePicker from "vue2-datepicker";

export default {
	mixins: [ContabilitaMixin, StruttureMixin, UtilityMixin],
	components: { DatePicker },
	data() {
		return {
			title: "",
			pathResource: "/contabilitadocumentotipo",
			tipoDocumentoSelezionato: null,
			causaleDocumentoSelezionata: null,
			localData: {
				tipoDocumentoId: null,
				tipoDocumentoCodice: null,
				tipoDocumentoDescrizione: null,
				causaleDocumentoId: null,
				causaleDocumentoDescrizione: null,
				causaleCodice: null,
				causaleDocumentoOperazioneMagazzino: null,
				causaleDocumentoOperazioneContabile: null,
				documentoNumero: null,
				documentoData: new Date().getTime(),
			},
		};
	},
	watch: {
		contabilitaCausaliDocumentoOptions(causali) {
			if (causali.length > 0) {
				if (causali.length == 1) {
					let causale = this.contabilitaCausaliDocumentoOptions[0];
					this.causaleDocumentoSelezionata = causale;
					this.localData.causaleDocumentoDescrizione = causale.descrizioneCausale;
					this.localData.causaleDocumentoOperazioneMagazzino = causale.operazioneMagazzino;
					this.localData.causaleDocumentoOperazioneContabile = causale.operazioneContabile;
					this.localData.causaleCodice = causale.codiceCausale;
					this.localData.causaleDocumentoId = causale.id;
					this.$emit("updateCausaleSelezionata", this.causaleDocumentoSelezionata);
				}
			}
		},
	},
	mounted() {
		this.id = this.$route.params.id;
	},
	methods: {
		init(jsonData) {
			this.localData = JSON.parse(JSON.stringify(jsonData));
			this.setPresidio();
			this.contabilitaTipoDocumentoLoadData(this.presidio.codiceStruttura);
			this.openModal();
			this.localData.documentoData = !this.localData.documentoData ? new Date().getTime() : this.localData.documentoData;
			if (this.localData.tipoDocumentoId != null) {
				this.contabilitaCausaliDocumentoLoadData(this.localData.tipoDocumentoId);
			}
		},
		isDisabled() {
			return this.id != null && this.id != '-1'
		},
		onChangeTipoDocumento(id) {
			if (id) {
				let tipiDocumento = this.contabilitaTipoDocumentoOptions.filter((e) => e.id === id);
				this.tipoDocumentoSelezionato = tipiDocumento[0];
				this.localData.tipoDocumentoDescrizione = this.tipoDocumentoSelezionato.descrizioneTipoDocumento;
				this.localData.tipoDocumentoCodice = this.tipoDocumentoSelezionato.codiceTipoDocumento;
				this.localData.tipoDocumento = this.tipoDocumentoSelezionato.tipoDocumento;
				this.contabilitaCausaliDocumentoLoadData(id);
				this.localData.causaleDocumentoId = null;
				this.localData.documentoNumero = null;
			}
			this.$emit("updateTipoDocumento", this.tipoDocumentoSelezionato);
		},
		onChangeCausaleDocumento(id) {
			if (id) {
				let causaliDocumento = this.contabilitaCausaliDocumentoOptions.filter((e) => e.id === id);
				this.causaleDocumentoSelezionata = causaliDocumento[0];
				this.localData.causaleDocumentoDescrizione = this.causaleDocumentoSelezionata.descrizioneCausale;
				this.localData.causaleDocumentoOperazioneMagazzino = this.causaleDocumentoSelezionata.operazioneMagazzino;
				this.localData.causaleDocumentoOperazioneContabile = this.causaleDocumentoSelezionata.operazioneContabile;
				this.localData.causaleCodice = this.causaleDocumentoSelezionata.codiceCausale;
				this.localData.documentoNumero = null;
			}
			this.$emit("updateCausaleSelezionata", this.causaleDocumentoSelezionata);
		},
		getCausaleDocumentoSelezionata() {
			return this.causaleDocumentoSelezionata;
		},
		onShowDatiDocumento() {


		},
		onResetDatiDocumento() {
			this.localData = {
				tipoDocumentoId: null,
				tipoDocumentoCodice: null,
				tipoDocumentoDescrizione: null,
				causaleDocumentoId: null,
				causaleDocumentoDescrizione: null,
				causaleCodice: null,
				causaleDocumentoOperazioneMagazzino: null,
				causaleDocumentoOperazioneContabile: null,
				documentoNumero: null,
				documentoData: new Date().getTime(),
			};
		},
		isTastoNumeroDocumentoEnabled() {
			let esito = true;
			if (this.localData.tipoDocumentoId) {
				let tipoDoc = this.contabilitaTipoDocumentoOptions.filter((e) => e.id == this.localData.tipoDocumentoId);

				if (tipoDoc[0])
					if (!tipoDoc[0].codiceNumeratore) {
						esito = false;
					}
			}
			return esito;
		},
		closeModal() {
			let me = this;
			me.$refs.mdlDatiDocumento.hide();
		},
		openModal() {
			let me = this;
			me.$refs.mdlDatiDocumento.show();
		},
		onOkModificaDatiDocumento(event) {
			let me = this;
			//event.preventDefault();
			let validation = this.validazione();
			if (!validation.esito) {
				this.generaBtoast(validation);
				event.preventDefault();
				return;
			}
			me.$emit("update", me.localData);
			me.closeModal();
		},
		validazione() {
			let esito = true;
			let msg = "";

			if (this.localData.tipoDocumentoId == null || this.localData.tipoDocumentoId.trim() == "") {
				msg += "Tipo Documento non valido ! #";
				esito = false;
			}

			if (this.localData.causaleDocumentoId == null || this.localData.causaleDocumentoId.trim() == "") {
				msg += "Causale documento non valida ! #";
				esito = false;
			}

			if (this.localData.tipoDocumentoId) {
				let tipoDoc = this.contabilitaTipoDocumentoOptions.filter((e) => e.id == this.localData.tipoDocumentoId);
				if (tipoDoc[0])
					if (!tipoDoc[0].codiceNumeratore) {
						if (this.localData.documentoNumero == null) {
							msg += "Numero documento Obbligatorio ! #";
							esito = false;
						}
					}
			}

			return { esito: esito, msg: msg };
		},
		setPresidio() {
			let tmpPresidio = window.localStorage.getItem("presidio");
			if (tmpPresidio) {
				this.presidio = JSON.parse(tmpPresidio);
				this.strutturaLoadDataByCodice(this.presidio.codiceStruttura);
			}
		},
		generaBtoast(validation) {
			toast.validation(validation)
		},
	},
};
</script>

<style></style>
